import Immutable from 'immutable'
import _ from 'lodash'
import {
  FETCH_RETAILERS_REQUEST,
  FETCH_RETAILERS_SUCCESS,
  FETCH_RETAILERS_ERROR,
  GET_RETAILER_REQUEST,
  GET_RETAILER_SUCCESS,
  GET_RETAILER_ERROR,
  SAVE_RETAILER_REQUEST,
  SAVE_RETAILER_SUCCESS,
  SAVE_RETAILER_ERROR,
  DELETE_RETAILER_REQUEST,
  DELETE_RETAILER_SUCCESS,
  DELETE_RETAILER_ERROR,
  CREATE_RETAILER,
  DELETE_RETAILER_IMAGE_SUCCESS,
  DELETE_RETAILER_REP_IMAGE_SUCCESS,
  DELETE_RETAILER_MASTHEAD_IMAGE_SUCCESS,
  CHECK_RETAILER_CUSTOM_URL_REQUEST,
  CHECK_RETAILER_CUSTOM_URL_SUCCESS,
  CHECK_RETAILER_CUSTOM_URL_ERROR,
  RESET_CHECK_RETAILER_CUSTOM_URL,
  CONNECT_STRIPE_REQUEST,
  CONNECT_STRIPE_ERROR,
  ADD_FEATURE_SELLER_REQUEST,
  ADD_FEATURE_SELLER_ERROR,
  ADD_FEATURE_SELLER_SUCCESS,
  Delete_Comment_REQUEST,
  Delete_Comment_SUCCESS,
  Delete_Comment_ERROR,
  Delete_Review_REQUEST,
  Delete_Review_SUCCESS,
  Delete_Review_ERROR,
  Delete_Product_REQUEST,
  Delete_Product_SUCCESS,
  Delete_Product_ERROR,
  GET_REVIEW_REQUEST,
  GET_REVIEW_ERROR,
  GET_REVIEW_SUCCESS,

  REMOVE_FEATURE_SELLER_ERROR,
  REMOVE_FEATURE_SELLER_SUCCESS,
  REMOVE_FEATURE_SELLER_REQUEST,
  ALL_RETAILER_REQUEST,
  ALL_RETAILER_SUCCESS,
  ALL_RETAILER_ERROR,

  GET_COMMENT_REQUEST,
  GET_COMMENT_SUCCESS,
  GET_COMMENT_ERROR,

  ADD_BEST_COLLECTION_REQUEST,
  ADD_BEST_COLLECTION_SUCCESS,
  ADD_BEST_COLLECTION_ERROR,

  REMOVE_BEST_COLLECTION_REQUEST,
  REMOVE_BEST_COLLECTION_SUCCESS,
  REMOVE_BEST_COLLECTION_ERROR,

  GET_BEST_COLLECTION_REQUEST,
  GET_BEST_COLLECTION_SUCCESS,
  GET_BEST_COLLECTION_ERROR,
  COMMENTED_ITEMS_REQUEST,
  COMMENTED_ITEMS_SUCCESS,
  COMMENTED_ITEMS_ERROR,
  FETCH_USERS_ERROR,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_REQUEST

} from '../actions/retailer'
import { Entity, Collection } from '../utils/jsonapi'
import { parseErrorResponse } from '../utils/errors'

export default (
  state = Immutable.Map({
    inProgress: false,
    retailers: null,
    users: null,
    selectedRetailer: null,
    checkingCustomUrl: false,
    validCustomUrl: false,
    error: null,
    connectStripeInProgress: false,
    connectStripeError: null,
    addFeature: null,
    deleteComment: null,
    deleteReview: null,
    deleteProduct: null,
    removeFeature: null,
    selectedReviews: null,
    selectedComments: null,

    addBestCollection: null,
    removeBestCollection: null,
    bestCollection: null,
    commentedItemLists: null,
  }),
  action
) => {
  switch (action.type) {
    case FETCH_RETAILERS_REQUEST:
    case FETCH_USERS_REQUEST:
    case GET_RETAILER_REQUEST:
      return state.set('inProgress', true).set('error', null).set('selectedRetailer', null)
    case SAVE_RETAILER_REQUEST:
    case DELETE_RETAILER_REQUEST:

      return state.set('inProgress', true).set('error', null)
    case FETCH_RETAILERS_ERROR:
    case FETCH_USERS_ERROR:
    case GET_RETAILER_ERROR:
    case SAVE_RETAILER_ERROR:
    case DELETE_RETAILER_ERROR:

      return state
        .set('inProgress', false)
        .set('error', parseErrorResponse(action.error))
    case FETCH_RETAILERS_SUCCESS:
      if (_.isFunction(action.callback)) {
        action.callback(action.retailers)
      }
      return state.set('inProgress', false).set('retailers', action.retailers)
    case FETCH_USERS_SUCCESS:
      if (_.isFunction(action.callback)) {
        action.callback(action.users)
      }
      return state.set('inProgress', false).set('users', action.users)
    case GET_RETAILER_SUCCESS:
      return state
        .set('inProgress', false)
        .set('selectedRetailer', action.retailer)
    case SAVE_RETAILER_SUCCESS:
      return state
        .set('inProgress', false)
        .set('retailers', null)
        .set('selectedRetailer', action.retailer)
    case DELETE_RETAILER_SUCCESS:
      return state
        .set('inProgress', false)
        .set('retailers', null)
        .set('selectedRetailer', null)
    case CREATE_RETAILER:
      return state.set(
        'selectedRetailer',
        new Entity({
          id: '',
          type: 'retailer',
          attributes: {
            username: '',
            password: '',
            verifyPassword: '',
            contactDetails: 'phone,email',
            storeRepTitle: 'jeweler',
            taxRate: '',
            shippingDestination: 'international',
            shippingFee: '',
            returnPolicy: 'return-accepted',
            returnPeriod: '',
            monOpen: true,
            tueOpen: true,
            wedOpen: true,
            thuOpen: true,
            friOpen: true,
            satOpen: true,
            sunOpen: true
          }
        })
      )
    case DELETE_RETAILER_IMAGE_SUCCESS: {
      const retailer = state.get('selectedRetailer').clone()
      retailer.removeRelated('images', action.image.id)
      // Also remove from galleryImages stored as a flat attribute array (new API structure)
      const galleryImages = retailer.get('galleryImages')
      if (galleryImages) {
        retailer.set('galleryImages', galleryImages.filter(img => img.id !== action.image.id))
      }
      return state.set('selectedRetailer', retailer)
    }
    case DELETE_RETAILER_REP_IMAGE_SUCCESS: {
      const r = state.get('selectedRetailer').clone()
      r.removeRelated('imageRep')
      return state.set('selectedRetailer', r)
    }
    case DELETE_RETAILER_MASTHEAD_IMAGE_SUCCESS: {
      const r = state.get('selectedRetailer').clone()
      r.removeRelated('imageMastHead')
      r.set('profileMastHead', null)
      return state.set('selectedRetailer', r)
    }
    case CHECK_RETAILER_CUSTOM_URL_REQUEST:
      return state
        .set('checkingCustomUrl', true)
        .set('error', null)
        .set('validCustomUrl', false)
    case CHECK_RETAILER_CUSTOM_URL_SUCCESS:
      return state
        .set('checkingCustomUrl', false)
        .set('validCustomUrl', action.result)
    case CHECK_RETAILER_CUSTOM_URL_ERROR:
      return state
        .set('checkingCustomUrl', false)
        .set('validCustomUrl', false)
        .set('error', { publicLink: action.error })
    case RESET_CHECK_RETAILER_CUSTOM_URL:
      return state
        .set('checkingCustomUrl', false)
        .set('validCustomUrl', false)
        .set('error', null)


    case CONNECT_STRIPE_REQUEST:
      return state.set('connectStripeInProgress', true).set('error', null)
    case CONNECT_STRIPE_ERROR:
      return state
        .set('connectStripeInProgress', false)
        .set('error', action.error)



    //add feature

    case ADD_FEATURE_SELLER_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('addFeature', null)
    case ADD_FEATURE_SELLER_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('addFeature', action.addFeature)
    case ADD_FEATURE_SELLER_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)

    // delete comment
    case Delete_Comment_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('deleteComment', null)
    case Delete_Comment_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('deleteComment', action.deleteComment)
    case Delete_Comment_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)

    // delete Review
    case Delete_Review_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('deleteReview', null)
    case Delete_Review_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('deleteReview', action.deleteReview)
    case Delete_Review_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)


    // delete Product
    case Delete_Product_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('deleteProduct', null)
    case Delete_Product_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('deleteProduct', action.deleteProduct)
    case Delete_Product_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)
    // case ADD_FEATURE_SELLER_REQUEST:
    //   return state
    //     .set('inProgress', true)
    //     .set('error', null)
    //     .set('addFeature', null)
    // case ADD_FEATURE_SELLER_SUCCESS:
    //   return state
    //     .set('inProgress', false)
    //     .set('error', null)
    //     .set('addFeature', action.addFeature)
    // case ADD_FEATURE_SELLER_ERROR:
    //   return state
    //     .set('inProgress', false)
    //     .set('error', action.error)



    //list review
    case GET_REVIEW_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('selectedReviews', null)
    case GET_REVIEW_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('selectedReviews', action.Review)

    case GET_REVIEW_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)

    //remove feature
    case REMOVE_FEATURE_SELLER_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('removeFeature', null)
    case REMOVE_FEATURE_SELLER_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('removeFeature', action.removeFeature)
    case REMOVE_FEATURE_SELLER_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)
    //seller
    case ALL_RETAILER_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('retailers', null)
    case ALL_RETAILER_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('retailers', action.retailers)
    case ALL_RETAILER_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)


    //list Comment
    case GET_COMMENT_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('selectedComments', null)
    case GET_COMMENT_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('selectedComments', action.Comments)

    case GET_COMMENT_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)


    //add feature

    case ADD_BEST_COLLECTION_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('addBestCollection', null)
    case ADD_BEST_COLLECTION_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('addBestCollection', action.addBestCollection)
    case ADD_BEST_COLLECTION_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)

    //remove feature
    case REMOVE_BEST_COLLECTION_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('removeBestCollection', null)
    case REMOVE_BEST_COLLECTION_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('removeBestCollection', action.removeBestCollection)
    case REMOVE_BEST_COLLECTION_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)


    //list Comment
    case GET_BEST_COLLECTION_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('bestCollection', null)
    case GET_BEST_COLLECTION_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('bestCollection', action.bestCollection)

    case GET_BEST_COLLECTION_ERROR:
      return state
        .set('inProgress', false)
        .set('error', action.error)
    //commented item
    case COMMENTED_ITEMS_REQUEST:
      return state
        .set('inProgress', true)
        .set('error', null)
        .set('commentedItemLists', null)
    case COMMENTED_ITEMS_SUCCESS:
      return state
        .set('inProgress', false)
        .set('error', null)
        .set('commentedItemLists', action.commentedItems)

    case COMMENTED_ITEMS_ERROR:
      return state
        .set('inProgress', false)
        .set('commentedItemLists', false)
        .set('error', action.error)



    default:
      return state
  }
}
